import { createPageLayout } from '@opengov/app-core/layout';

import { getModalComponent } from '../../../../modals';

export const StoriesPage = createPageLayout(getModalComponent);
